<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import UniloginButton from "@/components/UniloginButton.vue";

const { t } = useI18n();

const { redirectUrl: queryRedirectUrl } = useRoute().query;
const redirectUrl = (queryRedirectUrl as string) ?? "/dictionary";
</script>

<template>
  <main class="container p-0 d-flex flex-column justify-content-center align-items-center">
    <UniloginButton :tag="TgButton" size="lg" :redirect-url="redirectUrl">
      <i18n-t keypath="home.loginWithUnilogin">
        <template #unilogin>
          <span class="font-weight-bold">{{ t("home.loginButton") }}</span>
        </template>
      </i18n-t>
    </UniloginButton>
  </main>
</template>
